import React, { useState } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, Typography, Box, Radio, RadioGroup,
  FormControlLabel, FormControl, FormLabel, Divider,
  Stack, Paper
} from '@mui/material';
import {
  PaymentsOutlined, // Για μετρητά
  AccountBalanceOutlined, // Για κατάθεση
  QrCodeScannerOutlined // Για IRIS (ή κάτι παρόμοιο)
} from '@mui/icons-material';

export default function DepositDialog({ open, onClose, onSuccess, deviceId }) {
  // State για τις επιλογές
  const [amount, setAmount] = useState('10');
  const [method, setMethod] = useState('cash');

  // Λίστα με τους τρόπους πληρωμής για να κάνουμε map
  const paymentMethods = [
    { id: 'cash', label: 'Μετρητά', description: 'Μετρητά στο κατάστημα της Ροδόπολης', icon: <PaymentsOutlined /> },
    { id: 'bank', label: 'Κατάθεση', description: 'Κατάθεση στην τράπεζα Πειραιώς', icon: <AccountBalanceOutlined /> },
    { id: 'iris', label: 'IRIS', description: 'IRIS', icon: <QrCodeScannerOutlined /> },
  ];

  const handleDeposit = async () => {
    try {
      const token = localStorage.getItem('auth_token');
      const payload = {
        amount: Number(amount),
        method: method
      };

      const response = await fetch(`${process.env.REACT_APP_API_URL}/user/device/${deviceId}/deposit`, {
        method: 'PUT',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
      });

      if (response.ok) {
        const data = await response.json();
        onSuccess(data.balance);
        onClose();
      }
    } catch (error) {
      console.error("Deposit failed:", error);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="xs"
      PaperProps={{ sx: { borderRadius: 3, p: 1 } }}
    >
      <DialogTitle sx={{ fontWeight: 'bold' }}>Φόρτιση Ταμείου</DialogTitle>

      <DialogContent>
        {/* ΕΠΙΛΟΓΗ ΠΟΣΟΥ */}
        <FormControl component="fieldset" sx={{ mb: 3, width: '100%' }}>
          <FormLabel sx={{ fontWeight: 'bold', mb: 1 }}>Ποσό</FormLabel>
          <RadioGroup
            row
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
            sx={{ justifyContent: 'space-between' }}
          >
            {['10', '20', '30', '40', '50'].map((val) => (
              <FormControlLabel
                key={val}
                value={val}
                control={<Radio size="small" />}
                label={`${val}€`}
              />
            ))}
          </RadioGroup>
        </FormControl>

        <FormLabel sx={{ fontWeight: 'bold', mb: 1, display: 'block' }}>Πληρωμή</FormLabel>
        <Stack direction="row" spacing={1} sx={{ mt: 1, mb: 3 }}>
          {paymentMethods.map((m) => (
            <Paper
              key={m.id}
              variant="outlined"
              onClick={() => setMethod(m.id)}
              sx={{
                flex: 1,
                p: 1.5,
                cursor: 'pointer',
                textAlign: 'center',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: 0.5,
                borderColor: method === m.id ? 'primary.main' : 'divider',
                bgcolor: method === m.id ? 'primary.lightest' : 'transparent',
                borderWidth: 1,
                transition: '0.2s',
                '&:hover': { bgcolor: 'action.hover' }
              }}
            >
              <Box sx={{ color: method === m.id ? 'primary.main' : 'text.secondary' }}>
                {m.icon}
              </Box>
              <Typography variant="caption">
                {m.label}
              </Typography>
            </Paper>
          ))}
        </Stack>

        <Divider sx={{ my: 2 }} />

        <Box sx={{ p: 2, bgcolor: 'grey.50', borderRadius: 2 }}>
          <Typography variant="body2" color="text.secondary">Ποσό: <b>{amount}€</b></Typography>
          <Typography variant="body2" color="text.secondary">
            Πληρωμή: <b>{paymentMethods.find(m => m.id === method)?.description}</b>
          </Typography>
        </Box>
      </DialogContent>

      <DialogActions sx={{ pb: 2, px: 2 }}>
        <Button onClick={onClose} sx={{ color: 'text.secondary' }}>Ακύρωση</Button>
        <Button
          onClick={handleDeposit}
          variant="contained"
          color="primary"
          sx={{  }}
        >
          Πληρωμή
        </Button>
      </DialogActions>
    </Dialog>
  );
}
